import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import SimilarPosts from "../SearchAll/AllPosts/SimilarPosts";
import { useDispatch, useSelector } from "react-redux";
import {
  addtowishinpostbyid,
  getPostsById,
} from "../../../../redux/posts/action";
import Access from "../../../CustomComponents/Access/Access";
import getTimeDifference from "../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype,
} from "../../../Common/AllDateTimeReleventFormate";
import DownloadwithDisplayProper from "../../../Common/FilesRelevent/DownloadwithDisplayProper";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import GetPrice from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import GetLocation from "../../../CustomComponents/GetLocation";
import CustomeCategoryandSubcategory from "../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import { IS_LOGGED_IN_USER, decodeHtml } from "../../../../assests/extention/commonfunction";
import AbouttheClient from "../../../Common/AbouttheClient";
import HomeCommonNavigation from "../../../Common/HomeCommonNavigation";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import AllStatusLabels from "../SearchAll/AllPosts/AllStatusLabels";
import DeadlineComponents from "../../../Common/DeadlineComponents";
import img from '../../../../assests/imgs/contest.png'
import ParticipateImage from "../SearchContestParticipate/ContestDetails/ParticipateImage";

export default function JobDetails() {
  const laung = localStorage.getItem("laung");
  const navigate = useNavigate();
  const path = "Assets/scss/FindWork.module.scss";
  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const applyandbitjob = () => {
    setModal(true);
  };

  const addtowishlist11 = (id) => {
    dispatch(addtowishinpostbyid(id));
  };

  return (
    <div className=" project-section project-details col-lg-10 mx-auto">
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${laung ?? "en"}/jobapply/${posts.id}`}
          state={"state"}
          checkpermission={"apply_jobs"}
          masterID={posts.id && posts.id}
        />
      ) : (
        ""
      )}
      <p className="breadcrumbs">
        <HomeCommonNavigation type={posts?.type} />Job details
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-8">
          <div className="post-details p-0" style={{ border: "0" }}>
            <div className="filter-detail justify-contnt-between">
              <div className="w-100">
                <h5>
                  {decodeHtml(posts.title)} <span className="job">{getPosttype(posts.type)}</span>
                </h5>
                <div className="dollar-sec">
                  <p>
                    <GetPrice
                      type={posts?.type}
                      price={posts?.price}
                      price2={posts?.price2}
                      hiring_type={posts?.hiring_type}
                    />
                  </p>
                  {posts?.type == 3 ? (
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                        alt=""
                      />
                      Job type: {' '}
                      {posts?.work_location == 1
                        ? "Virtual"
                        : posts?.work_location == 2
                          ? "Physical"
                          : ""}
                    </p>
                  ) : (
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                        alt=""
                      />
                      <DeadlineComponents posts={posts} />
                    </p>
                  )}
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                      alt=""
                    />
                    Posted:{getTimeDifference(posts?.created_on)}
                  </p>
                </div>
                <GetLocation
                  type={posts?.type}
                  city_name={posts?.city_name}
                  country_title={posts?.country_title}
                />
                <CustomeCategoryandSubcategory posts={posts} />
                <div className="lang-sec">
                  <h6>Preferred language</h6>
                  <p>{posts.language_title}</p>
                </div>
                <div className="lang-sec">
                  <h6>Description</h6>
                  <CustomReactQuillDescription value={posts.description} />
                </div>
                <div className="lang-sec">
                  <h6>Competencies and expertise</h6>
                  <div className="skills-expert">
                    {posts.skills &&
                      Array.isArray(posts.skills) &&
                      posts.skills.map((item, index) => {
                        return <p key={index}> {decodeHtml(item.title)} </p>;
                      })}
                  </div>
                </div>
                {Array.isArray(posts?.files) &&
                  posts?.files &&
                  posts?.files?.length > 0 && (
                    <div className="lang-sec">
                      <h6>Attachments</h6>
                      <div className="images">
                        {posts?.files.map((item, index) => {
                          return <DownloadwithDisplayProper item={item} />;
                        })}
                      </div>
                    </div>
                  )}

                <div className="lang-sec">
                  <h6 className="activity-post"> Activity on this post</h6>
                  <div className="post-p">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                        alt=""
                      />
                      Proposal: {posts?.proposal_count}
                    </p>
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                        alt=""
                      />
                      Last viewed by client:
                      {getTimeDifference(posts?.last_viewed_client)}
                    </p>
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                        alt=""
                      />
                      Seen: {posts?.view_count}
                    </p>
                  </div>
                </div>
              </div>
              <button
                className="btn heart-btn"
                onClick={() => {
                  if (IS_LOGGED_IN_USER) {
                    posts.wishlist == 1
                      ? addtowishlist11(posts?.id, 1)
                      : addtowishlist11(posts?.id, 1);
                  } else {
                    setModal(true);
                  }
                }}
              >
                {posts.wishlist == 1 ? (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                    alt=""
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                    alt=""
                  />
                )}
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-4">
          <div className="like-project">
            <div className="first-sec">
              <ParticipateImage />
              <h5> {posts.is_mine == 1 ? "Your post" : "Like this job?"}</h5>
              <p>
                {posts.is_mine == 1
                  ? "Do you want to modify this post"
                  : "Apply to send your proposal"}
              </p>

              {posts.is_mine == 1 ? (
                ""
              ) : (
                <>
                  {!posts?.proposed_status ? (
                    <button className="btn" onClick={() => { applyandbitjob(); }}   >
                      Apply for job
                    </button>
                  ) : (
                    <>
                      <AllStatusLabels status_id={posts?.proposed_status} />
                    </>
                  )}
                </>
              )}
              {posts.is_mine == 1 && (
                <button
                  className="btn"
                  onClick={() =>
                    navigate(`/${laung ?? "en"}/account/updatejob/${posts.id}`)
                  }
                  disabled={posts?.proposal_count}
                >
                  Update
                </button>
              )}
            </div>
            {posts.is_mine == 1 ? (
              ""
            ) : (
              <AbouttheClient posts={posts} />
            )}
          </div>
        </div>
        <div className="col-lg-9 col-md-8">
          <SimilarPosts posts={posts} />
        </div>
      </div>
    </div>
  );
}
